var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 66,
    viewBox: "0 0 95 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 63.778,
    height: 46.995,
    fill: "#4493f9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(0.192 -0.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 95,
    height: 66,
    transform: "translate(-0.192 0.269)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(11.539 5.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(8.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 63.778,
    height: 47.666,
    rx: 7,
    fill: "#4493f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M97.763,235.42h21.216c.332,0,.664,0,.995-.019a1.492,1.492,0,0,0,1.332-2.385,6.573,6.573,0,0,0-.43-.682q-3.6-5.144-7.2-10.285c-1.4-1.993-3.172-2.141-4.888-.423-.967.968-1.9,1.97-2.915,2.89a2.8,2.8,0,0,1-3.847.042,6.4,6.4,0,0,1-.861-.977q-5.692-7.427-11.375-14.862c-1.532-2-3-1.875-4.136.366q-5.78,11.441-11.55,22.887a5.773,5.773,0,0,0-.453,1.213,1.635,1.635,0,0,0,1.179,2.078,5.2,5.2,0,0,0,1.408.152Q87,235.427,97.763,235.42Z",
    transform: "translate(-64.879 -193.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M289.1,107.473a6.953,6.953,0,1,0-6.941-6.983A7.008,7.008,0,0,0,289.1,107.473Z",
    transform: "translate(-247.45 -84.703)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 8.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M6.234,36.655V0H3.99A3.99,3.99,0,0,0,0,3.99v38.9a3.99,3.99,0,0,0,3.99,3.99H59.845a3.99,3.99,0,0,0,3.99-3.99V40.645H10.224a3.99,3.99,0,0,1-3.99-3.99",
    transform: "translate(0.358 0.656)",
    fill: "#4493f9"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImage);
export default __webpack_public_path__ + "static/media/ic_image.084019f3527e5d6db1fc127a02deee9b.svg";
export { ForwardRef as ReactComponent };